"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.f108 = void 0;
exports.f108 = {
    "la": [
        "Latn"
    ],
    "laa": [
        "Latn"
    ],
    "lab": [
        "Lina"
    ],
    "lac": [
        "Latn"
    ],
    "lad": [
        "Hebr",
        "Cyrl",
        "Latn"
    ],
    "lae": [
        "Deva",
        "Tibt"
    ],
    "laf": [
        "Zyyy"
    ],
    "lag": [
        "Latn"
    ],
    "lah": [
        "Arab",
        "Khoj",
        "Latn",
        "Mahj",
        "Zzzz"
    ],
    "lai": [
        "Latn"
    ],
    "laj": [
        "Latn"
    ],
    "lak": [
        "Latn"
    ],
    "lal": [
        "Latn"
    ],
    "lam": [
        "Latn"
    ],
    "lan": [
        "Latn"
    ],
    "lap": [
        "Latn"
    ],
    "laq": [
        "Latn"
    ],
    "lar": [
        "Latn"
    ],
    "las": [
        "Latn"
    ],
    "lau": [
        "Latn"
    ],
    "law": [
        "Latn"
    ],
    "lax": [
        "Beng",
        "Latn"
    ],
    "lay": [
        "Zyyy"
    ],
    "laz": [
        "Latn"
    ],
    "lb": [
        "Latn"
    ],
    "lba": [
        "Zyyy"
    ],
    "lbb": [
        "Latn"
    ],
    "lbc": [
        "Lisu"
    ],
    "lbe": [
        "Cyrl"
    ],
    "lbf": [
        "Deva",
        "Tibt"
    ],
    "lbg": [
        "Zyyy"
    ],
    "lbi": [
        "Latn"
    ],
    "lbj": [
        "Tibt"
    ],
    "lbl": [
        "Latn"
    ],
    "lbm": [
        "Deva"
    ],
    "lbn": [
        "Laoo",
        "Latn"
    ],
    "lbo": [
        "Zyyy"
    ],
    "lbq": [
        "Latn"
    ],
    "lbr": [
        "Deva"
    ],
    "lbs": [
        "Zxxx"
    ],
    "lbt": [
        "Latn"
    ],
    "lbu": [
        "Latn"
    ],
    "lbv": [
        "Latn"
    ],
    "lbw": [
        "Latn"
    ],
    "lbx": [
        "Latn"
    ],
    "lby": [
        "Latn"
    ],
    "lbz": [
        "Latn"
    ],
    "lcc": [
        "Latn"
    ],
    "lcd": [
        "Latn"
    ],
    "lce": [
        "Latn"
    ],
    "lcf": [
        "Latn"
    ],
    "lch": [
        "Latn"
    ],
    "lcl": [
        "Latn"
    ],
    "lcm": [
        "Latn"
    ],
    "lcp": [
        "Thai"
    ],
    "lcq": [
        "Latn"
    ],
    "lcs": [
        "Latn"
    ],
    "lda": [
        "Latn"
    ],
    "ldb": [
        "Latn"
    ],
    "ldd": [
        "Latn"
    ],
    "ldg": [
        "Latn"
    ],
    "ldh": [
        "Latn"
    ],
    "ldi": [
        "Latn"
    ],
    "ldj": [
        "Latn"
    ],
    "ldk": [
        "Latn"
    ],
    "ldl": [
        "Latn"
    ],
    "ldm": [
        "Latn"
    ],
    "ldn": [
        "Latn"
    ],
    "ldo": [
        "Latn"
    ],
    "ldp": [
        "Latn"
    ],
    "ldq": [
        "Latn"
    ],
    "lea": [
        "Latn"
    ],
    "leb": [
        "Latn"
    ],
    "lec": [
        "Latn"
    ],
    "led": [
        "Latn"
    ],
    "lee": [
        "Latn"
    ],
    "lef": [
        "Latn"
    ],
    "leh": [
        "Latn"
    ],
    "lei": [
        "Latn"
    ],
    "lej": [
        "Latn"
    ],
    "lek": [
        "Latn"
    ],
    "lel": [
        "Latn"
    ],
    "lem": [
        "Latn"
    ],
    "len": [
        "Latn"
    ],
    "leo": [
        "Latn"
    ],
    "lep": [
        "Lepc",
        "Tibt"
    ],
    "leq": [
        "Latn"
    ],
    "ler": [
        "Latn"
    ],
    "les": [
        "Latn"
    ],
    "let": [
        "Latn"
    ],
    "leu": [
        "Latn"
    ],
    "lev": [
        "Latn"
    ],
    "lew": [
        "Latn"
    ],
    "lex": [
        "Latn"
    ],
    "ley": [
        "Latn"
    ],
    "lez": [
        "Cyrl",
        "Aghb"
    ],
    "lfa": [
        "Latn"
    ],
    "lfn": [
        "Latn",
        "Cyrl"
    ],
    "lg": [
        "Latn",
        "Arab"
    ],
    "lga": [
        "Latn"
    ],
    "lgb": [
        "Latn"
    ],
    "lgg": [
        "Latn",
        "Arab"
    ],
    "lgh": [
        "Latn"
    ],
    "lgi": [
        "Latn"
    ],
    "lgk": [
        "Latn"
    ],
    "lgl": [
        "Latn"
    ],
    "lgm": [
        "Latn"
    ],
    "lgn": [
        "Latn"
    ],
    "lgq": [
        "Latn"
    ],
    "lgr": [
        "Latn"
    ],
    "lgt": [
        "Latn"
    ],
    "lgu": [
        "Latn"
    ],
    "lgz": [
        "Latn"
    ],
    "lha": [
        "Latn"
    ],
    "lhh": [
        "Latn"
    ],
    "lhi": [
        "Latn"
    ],
    "lhl": [
        "Zyyy"
    ],
    "lhm": [
        "Deva"
    ],
    "lhn": [
        "Latn"
    ],
    "lhp": [
        "Zyyy"
    ],
    "lhs": [
        "Syrc"
    ],
    "lht": [
        "Latn"
    ],
    "lhu": [
        "Latn"
    ],
    "li": [
        "Latn"
    ],
    "lia": [
        "Latn"
    ],
    "lib": [
        "Latn"
    ],
    "lic": [
        "Latn"
    ],
    "lid": [
        "Latn"
    ],
    "lie": [
        "Latn"
    ],
    "lif": [
        "Deva",
        "Limb"
    ],
    "lig": [
        "Latn"
    ],
    "lih": [
        "Latn"
    ],
    "lij": [
        "Latn"
    ],
    "lik": [
        "Latn"
    ],
    "lil": [
        "Latn",
        "Dupl"
    ],
    "lio": [
        "Latn"
    ],
    "lip": [
        "Latn"
    ],
    "liq": [
        "Latn"
    ],
    "lir": [
        "Latn"
    ],
    "lis": [
        "Lisu",
        "Latn"
    ],
    "liu": [
        "Latn"
    ],
    "liv": [
        "Latn"
    ],
    "liw": [
        "Latn"
    ],
    "lix": [
        "Latn"
    ],
    "liy": [
        "Latn"
    ],
    "liz": [
        "Latn"
    ],
    "lja": [
        "Latn"
    ],
    "lje": [
        "Latn"
    ],
    "lji": [
        "Latn"
    ],
    "ljl": [
        "Latn"
    ],
    "ljp": [
        "Latn",
        "Rjng"
    ],
    "ljw": [
        "Latn"
    ],
    "ljx": [
        "Latn"
    ],
    "lka": [
        "Latn"
    ],
    "lkb": [
        "Latn"
    ],
    "lkc": [
        "Latn"
    ],
    "lkd": [
        "Latn"
    ],
    "lke": [
        "Latn"
    ],
    "lkh": [
        "Tibt"
    ],
    "lki": [
        "Arab"
    ],
    "lkj": [
        "Latn"
    ],
    "lkl": [
        "Latn"
    ],
    "lkm": [
        "Latn"
    ],
    "lkn": [
        "Latn"
    ],
    "lko": [
        "Latn"
    ],
    "lkr": [
        "Latn"
    ],
    "lks": [
        "Latn"
    ],
    "lkt": [
        "Latn"
    ],
    "lku": [
        "Latn"
    ],
    "lky": [
        "Latn"
    ],
    "lla": [
        "Latn"
    ],
    "llb": [
        "Latn"
    ],
    "llc": [
        "Latn"
    ],
    "lld": [
        "Latn"
    ],
    "lle": [
        "Latn"
    ],
    "llf": [
        "Latn"
    ],
    "llg": [
        "Latn"
    ],
    "llh": [
        "Zyyy"
    ],
    "lli": [
        "Latn"
    ],
    "llj": [
        "Latn"
    ],
    "llk": [
        "Latn"
    ],
    "lll": [
        "Latn"
    ],
    "llm": [
        "Latn"
    ],
    "lln": [
        "Latn"
    ],
    "llp": [
        "Latn"
    ],
    "llq": [
        "Latn"
    ],
    "lls": [
        "Zxxx"
    ],
    "llu": [
        "Latn"
    ],
    "llx": [
        "Latn"
    ],
    "lma": [
        "Latn"
    ],
    "lmb": [
        "Latn"
    ],
    "lmc": [
        "Latn"
    ],
    "lmd": [
        "Latn"
    ],
    "lme": [
        "Latn"
    ],
    "lmf": [
        "Latn"
    ],
    "lmg": [
        "Latn"
    ],
    "lmh": [
        "Zyyy"
    ],
    "lmi": [
        "Latn"
    ],
    "lmj": [
        "Latn"
    ],
    "lmk": [
        "Latn",
        "Mymr"
    ],
    "lml": [
        "Latn"
    ],
    "lmn": [
        "Telu",
        "Deva",
        "Knda"
    ],
    "lmo": [
        "Latn"
    ],
    "lmp": [
        "Latn"
    ],
    "lmq": [
        "Latn"
    ],
    "lmr": [
        "Latn"
    ],
    "lmu": [
        "Latn"
    ],
    "lmv": [
        "Latn"
    ],
    "lmw": [
        "Latn"
    ],
    "lmx": [
        "Latn"
    ],
    "lmy": [
        "Latn"
    ],
    "lmz": [
        "Zyyy"
    ],
    "ln": [
        "Latn"
    ],
    "lna": [
        "Latn"
    ],
    "lnb": [
        "Latn"
    ],
    "lnd": [
        "Latn"
    ],
    "lng": [
        "Latn",
        "Runr"
    ],
    "lnh": [
        "Latn"
    ],
    "lni": [
        "Latn"
    ],
    "lnj": [
        "Latn"
    ],
    "lnl": [
        "Latn"
    ],
    "lnm": [
        "Latn"
    ],
    "lnn": [
        "Latn"
    ],
    "lno": [
        "Latn"
    ],
    "lns": [
        "Latn"
    ],
    "lnu": [
        "Latn"
    ],
    "lnw": [
        "Latn"
    ],
    "lnz": [
        "Latn"
    ],
    "lo": [
        "Laoo"
    ],
    "loa": [
        "Latn"
    ],
    "lob": [
        "Latn"
    ],
    "loc": [
        "Latn"
    ],
    "loe": [
        "Latn"
    ],
    "lof": [
        "Zyyy"
    ],
    "log": [
        "Latn"
    ],
    "loh": [
        "Latn"
    ],
    "loi": [
        "Latn"
    ],
    "loj": [
        "Latn"
    ],
    "lok": [
        "Latn"
    ],
    "lol": [
        "Latn"
    ],
    "lom": [
        "Latn",
        "Loma"
    ],
    "lon": [
        "Latn"
    ],
    "loo": [
        "Latn"
    ],
    "lop": [
        "Latn"
    ],
    "loq": [
        "Latn"
    ],
    "lor": [
        "Latn"
    ],
    "los": [
        "Latn"
    ],
    "lot": [
        "Latn",
        "Arab"
    ],
    "lou": [
        "Latn"
    ],
    "lov": [
        "Zyyy"
    ],
    "low": [
        "Latn"
    ],
    "lox": [
        "Latn"
    ],
    "loy": [
        "Deva",
        "Tibt"
    ],
    "loz": [
        "Latn"
    ],
    "lpa": [
        "Latn"
    ],
    "lpe": [
        "Latn"
    ],
    "lpn": [
        "Latn"
    ],
    "lpo": [
        "Plrd",
        "Lisu"
    ],
    "lpx": [
        "Latn"
    ],
    "lra": [
        "Latn"
    ],
    "lrc": [
        "Arab"
    ],
    "lre": [
        "Zyyy"
    ],
    "lrg": [
        "Latn"
    ],
    "lri": [
        "Latn"
    ],
    "lrk": [
        "Arab"
    ],
    "lrl": [
        "Arab"
    ],
    "lrm": [
        "Latn"
    ],
    "lrn": [
        "Latn"
    ],
    "lro": [
        "Latn"
    ],
    "lrr": [
        "Zyyy"
    ],
    "lrt": [
        "Latn"
    ],
    "lrv": [
        "Latn"
    ],
    "lrz": [
        "Latn"
    ],
    "lsa": [
        "Arab"
    ],
    "lsb": [
        "Zxxx"
    ],
    "lsd": [
        "Hebr"
    ],
    "lse": [
        "Latn"
    ],
    "lsg": [
        "Zxxx"
    ],
    "lsh": [
        "Zyyy"
    ],
    "lsi": [
        "Latn"
    ],
    "lsl": [
        "Zxxx"
    ],
    "lsm": [
        "Latn"
    ],
    "lsn": [
        "Zxxx"
    ],
    "lso": [
        "Zxxx"
    ],
    "lsp": [
        "Zxxx"
    ],
    "lsr": [
        "Latn"
    ],
    "lss": [
        "Arab"
    ],
    "lst": [
        "Zxxx"
    ],
    "lsv": [
        "Zxxx"
    ],
    "lsy": [
        "Zxxx"
    ],
    "lt": [
        "Latn",
        "Latf"
    ],
    "ltc": [
        "Hans",
        "Hant"
    ],
    "ltg": [
        "Latn"
    ],
    "lth": [
        "Latn"
    ],
    "lti": [
        "Latn"
    ],
    "ltn": [
        "Latn"
    ],
    "lto": [
        "Latn"
    ],
    "lts": [
        "Latn"
    ],
    "ltu": [
        "Latn"
    ],
    "lu": [
        "Latn"
    ],
    "lua": [
        "Latn"
    ],
    "luc": [
        "Latn"
    ],
    "lud": [
        "Latn"
    ],
    "lue": [
        "Latn"
    ],
    "luf": [
        "Latn"
    ],
    "lui": [
        "Latn"
    ],
    "luj": [
        "Latn"
    ],
    "luk": [
        "Tibt"
    ],
    "lul": [
        "Latn"
    ],
    "lum": [
        "Latn"
    ],
    "lun": [
        "Latn"
    ],
    "luo": [
        "Latn"
    ],
    "lup": [
        "Latn"
    ],
    "luq": [
        "Latn"
    ],
    "lur": [
        "Latn"
    ],
    "lus": [
        "Latn",
        "Beng",
        "Brai"
    ],
    "lut": [
        "Latn"
    ],
    "luu": [
        "Deva"
    ],
    "luv": [
        "Zyyy"
    ],
    "luw": [
        "Latn"
    ],
    "luy": [
        "Latn"
    ],
    "luz": [
        "Arab"
    ],
    "lv": [
        "Latn",
        "Brai"
    ],
    "lva": [
        "Latn"
    ],
    "lvi": [
        "Zyyy"
    ],
    "lvk": [
        "Latn"
    ],
    "lvu": [
        "Latn"
    ],
    "lwa": [
        "Latn"
    ],
    "lwe": [
        "Latn"
    ],
    "lwg": [
        "Latn"
    ],
    "lwh": [
        "Latn"
    ],
    "lwl": [
        "Thai"
    ],
    "lwm": [
        "Thai"
    ],
    "lwo": [
        "Latn"
    ],
    "lws": [
        "Zxxx"
    ],
    "lwt": [
        "Latn"
    ],
    "lwu": [
        "Zyyy"
    ],
    "lww": [
        "Latn"
    ],
    "lxm": [
        "Latn"
    ],
    "lya": [
        "Tibt"
    ],
    "lyg": [
        "Zyyy"
    ],
    "lyn": [
        "Latn"
    ],
    "lzh": [
        "Hans",
        "Hant"
    ],
    "lzl": [
        "Latn"
    ],
    "lzn": [
        "Latn"
    ],
    "lzz": [
        "Latn",
        "Geor"
    ]
};
